@if (product$ | async; as product) {
  <ul class="campaign-icons-list">
    <li class="marketplace">
      <app-uig-marketplace-icon [marketplace]="product.marketplace" [vendor]="product.vendor" [displayText]="true"></app-uig-marketplace-icon>
    </li>
    @for (campaign of product.campaignsTypes; track campaign) {
      <li>
        <img src="{{ mediaService.resolveAbsoluteUrl(campaign.url) }}" title="{{ campaign.name }}" />
        <span>{{ campaign.name }}</span>
      </li>
    }
  </ul>
}